import api from './api';

export const eventParticipationService = {
  getEventParticipations: (eventId) => api.get(`/events/${eventId}/participations`),
  getAvailableTimeSlots: (eventId) => api.get(`/events/${eventId}/time-slots`),
  createParticipation: (eventId, data) => api.post(`/event-participations/events/${eventId}/participations`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  updateParticipationStatus: (id, status) => api.put(`/event-participations/${id}/status`, { status }),
  deleteParticipation: (id) => api.delete(`/event-participations/${id}`),
  uploadParticipationImage: (id, formData) => api.post(`/event-participations/${id}/image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
};
